import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="dossier" maskId="round-filled-radius-0-stroke-1.5-IconDossier"><path d="M2 4.75C2 4.33579 2.33579 4 2.75 4H8V9.5H22V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75Z" fill="currentColor"/><path d="M9.5 4H15V8H9.5V4Z" fill="currentColor"/><path d="M16.5 4H21.25C21.6642 4 22 4.33579 22 4.75V8H16.5V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDossier;
